// 상태코드 → 사용자 메시지 (SPEC.md 에러표). 매핑 없으면 일반 메시지.
const STATUS_MESSAGES: Record<number, string> = {
  403: '권한이 없거나 비활성 상태입니다.',
  404: '대상을 찾을 수 없습니다.',
  409: '이미 존재하거나 사용 중이라 처리할 수 없습니다.',
  422: '입력값을 확인해주세요.',
};

// 필드명 → 메시지 (422 detail에서 추출, 폼 하이라이트용)
export type FieldErrors = Record<string, string>;

export class ApiError extends Error {
  readonly status: number;
  readonly userMessage: string;
  readonly fieldErrors?: FieldErrors;
  // 백엔드 detail 원문(문자열일 때). 호출부가 더 친절한 메시지를 만들 때 활용.
  readonly detail?: string;

  constructor(status: number, userMessage: string, fieldErrors?: FieldErrors, detail?: string) {
    super(userMessage);
    this.name = 'ApiError';
    this.status = status;
    this.userMessage = userMessage;
    this.fieldErrors = fieldErrors;
    this.detail = detail;
  }
}

type ValidationItem = { loc: (string | number)[]; msg: string };

function parseFieldErrors(detail: unknown): FieldErrors | undefined {
  if (!Array.isArray(detail)) return undefined;
  const out: FieldErrors = {};
  for (const item of detail as ValidationItem[]) {
    if (!item?.loc) continue;
    const field = item.loc.filter((p) => typeof p === 'string').at(-1);
    if (field) out[String(field)] = item.msg;
  }
  return Object.keys(out).length ? out : undefined;
}

export function apiErrorFromResponse(status: number, body: unknown): ApiError {
  const message = STATUS_MESSAGES[status] ?? '요청을 처리하지 못했습니다.';
  const rawDetail =
    body && typeof body === 'object' && 'detail' in body
      ? (body as { detail: unknown }).detail
      : undefined;
  const detail = typeof rawDetail === 'string' ? rawDetail : undefined;
  const fieldErrors = status === 422 ? parseFieldErrors(rawDetail) : undefined;
  return new ApiError(status, message, fieldErrors, detail);
}
